// Used for the tab keys of the dataset add view as well as for
// distinguishing between the add type after successful import.
export enum DatasetAddType {
  UPLOAD = "upload",
  REMOTE = "remote",
  COMPOSE = "compose",
}
